module.exports = __webpack_public_path__ + "img/icon-question-rating-skin-radio_button.fb996118.svg";